export const TerminationSectionData = {
    countries: [
      {
        country: "South Africa",
        section: "Termination",
        details: {
          termination_process: {
            description:
              "The termination process varies according to the employment agreement or collective agreement in place and is based on the type of contract and reason for termination.",
          },
          notice_period: {
            description:
              "The notice period for employees can differ and is stipulated in the employment contract/collective bargaining agreement. If the notice period is not mentioned in the employment contract, the minimum required by law is dependent on the employee’s length of service as below:",
            periods: {
              "0_to_6_months": "1 week’s notice",
              "6_months_to_1_year": "2 weeks’ notice",
              "1_plus_years": "4 weeks’ notice",
            },
            additional_info:
              "If a longer notice period was agreed in the employment contract, it must be honored.",
          },
          severance_pay: {
            description:
              "Severance pay in South Africa is only payable in the event of a dismissal for operational requirements.",
            details: {
              entitlement:
                "Employees are entitled to one week’s severance pay for every year of completed service unless the employment contract has been terminated due to poor performance or misconduct; in this case, no severance payment is due.",
              unfair_termination:
                "If the termination is procedurally unfair or reinstatement is not practical, the employee might be entitled to compensation equal to up to 12 months.",
            },
          },
          probation_period: {
            description:
              "Probation or trial periods are generally set within the employee’s employment contract; however, standard practice in South Africa is three months.",
            common_practice: "The common practice is a probation period of 3-6 months.",
            additional_info: {
              duration_reasonable:
                "The duration of the probation period must be reasonable in regard to the period it is required to determine the employee’s suitability for the job.",
              termination_guidelines:
                "An employer cannot terminate the employment at the end of the probation period and will be required to follow a fair performance management process and provide the employee with reasonable guidance and training before terminating their employment.",
            },
          },
        },
      },
      {
        country: "India",
        section: "Termination",
        details: {
          termination_process: {
            description:
              "In India, the termination process is governed by the terms of the employment contract, labor laws, and, if applicable, collective bargaining agreements. Employers must provide a valid reason and follow due process, including serving the appropriate notice period.",
          },
          notice_period: {
            description:
              "The notice period is generally stipulated in the employment contract. In the absence of specific terms, the notice period may vary by industry and job role. Standard notice periods are:",
            periods: {
              "below_1_year": "1 month",
              "1_to_5_years": "2 months",
              "5_plus_years": "3 months",
            },
          },
          severance_pay: {
            description:
              "Severance pay is provided in certain cases such as retrenchment. The Industrial Disputes Act mandates 15 days’ pay for every completed year of service.",
          },
          probation_period: {
            description:
              "The probation period in India is typically 3 to 6 months but may extend to 1 year based on the employment contract.",
          },
        },
      },
      {
        country: "United States",
        section: "Termination",
        details: {
          termination_process: {
            description:
              "In the U.S., most employment is 'at-will,' allowing employers to terminate an employee without cause, provided it is not discriminatory or in violation of a contract.",
          },
          notice_period: {
            description:
              "Notice periods are typically not required under U.S. federal law unless specified in an employment agreement.",
          },
          severance_pay: {
            description:
              "Severance pay is not mandatory but is often provided as a goodwill gesture or stipulated in contracts.",
          },
          probation_period: {
            description:
              "Probation periods vary by employer and are generally 3 months but are not legally mandated.",
          },
        },
      },
      {
        country: "United Kingdom",
        section: "Termination",
        details: {
          termination_process: {
            description:
              "In the UK, termination procedures must comply with employment law, ensuring fairness and adherence to notice periods outlined in the employment contract.",
          },
          notice_period: {
            description:
              "Notice periods depend on the employment contract or statutory minimums:",
            periods: {
              "below_2_years": "1 week",
              "2_plus_years": "1 week for each year of service (up to 12 weeks)",
            },
          },
          severance_pay: {
            description:
              "Statutory redundancy pay is based on age, weekly pay, and years of service.",
          },
          probation_period: {
            description:
              "Standard probation periods range from 3 to 6 months, with reviews to confirm permanent employment.",
          },
        },
      },
      {
        country: "Australia",
        section: "Termination",
        details: {
          termination_process: {
            description:
              "Termination processes in Australia must comply with the Fair Work Act, which outlines notice requirements, valid reasons, and due process.",
          },
          notice_period: {
            description:
              "Notice periods depend on the employment contract and statutory minimums:",
            periods: {
              "below_1_year": "1 week",
              "1_to_3_years": "2 weeks",
              "3_to_5_years": "3 weeks",
              "5_plus_years": "4 weeks",
            },
          },
          severance_pay: {
            description:
              "Employees are entitled to redundancy pay based on the Fair Work Act, varying by years of service.",
          },
          probation_period: {
            description:
              "Probation periods are typically 6 months and are outlined in the employment contract.",
          },
        },
      },
    ],
  };
  